import { LoginForm, LoginHeader, BackgroundBlur, HeroSection } from '../components/login';
import { useAuth } from '../components/login/hooks';

export default function Login() {
  const { authenticate, error, isLoading } = useAuth();

  return (
    <div className="flex h-full w-full bg-white dark:bg-slate-900 overflow-hidden">
      <div className="w-full lg:w-[48%] flex items-center justify-center p-5 sm:p-8 relative bg-[#f4f6f8] dark:bg-slate-900">
        <BackgroundBlur />
        <div className="w-full max-w-[25rem] relative z-10">
          <LoginHeader />
          <div className="bg-white dark:bg-slate-800/80 p-6 rounded-[1.5rem] shadow-xl shadow-slate-200/40 dark:shadow-none border border-slate-100 dark:border-slate-700/50 backdrop-blur-xl">
            <LoginForm onSubmit={authenticate} error={error} isLoading={isLoading} />
          </div>
   
        </div>
      </div>
      <HeroSection />

    </div>
  );
}
